export const ADMIN_MENU_ID = "admin-menu";
export const TOP_MENU_ID = "top-menu";
export const USER_MENU_ID = "user-menu";
export const CREATE_MENU_ID = "create-menu";

export const areaSidebarMenuId = (areaId: string) => `${areaId}-sidebar`;
